/**
 * useIsBroker — returns true when the logged-in user's role is
 * "Broker". Used to gate Broker-tier visibility (sidebar items,
 * dashboard layouts, hide-vs-show on action surfaces).
 *
 * Single source of truth so the role-name string only lives in one
 * place — if the role is ever renamed or the comparison needs to
 * support multiple aliases, only this helper changes.
 */

import { useAuth } from '../contexts/AuthContext';

export function useIsBroker(): boolean {
  const { role } = useAuth();
  return role?.name === 'Broker';
}
